import React, { FC } from "react";
import { InputParameters } from "../InputParameters";
import { InputAdornment, TextField } from "@mui/material";
import "./style.css";

export interface InputIntegerProperties extends InputParameters {
  allowNegative?: boolean;
  maxLength?: number;
  minLength?: number;
  onChangeValue?: Function;
  sufix?: React.ReactNode;
  className?: string;
  hasError?: boolean;
}

const InputInteger: FC<InputIntegerProperties> = ({
  id = "",
  label = "",
  value = "",
  size = "small",
  margin = "normal",
  variant = "outlined",
  fullWidth = true,
  allowNegative = false,
  onChangeValue,
  maxLength = 3,
  name = "input-int",
  sufix = undefined,
  prefix = undefined,
  disabled = false,
  helperText,
  type,
  className,
  onBlur,
  hasError = false,
}) => {

  const regexNegative: RegExp = /^\-/gm;

  const numberValue = Number(value || 0);
  const customValue = (numberValue > 0 && numberValue < 10) ? String(numberValue)?.replace('0', '') : value;

  return (
    <TextField
      fullWidth={fullWidth}
      id={id}
      className={className}
      type={type}
      label={label}
      variant={variant}
      size={size}
      name={name}
      margin={margin}
      disabled={disabled}
      value={customValue}
      helperText={helperText}
      InputProps={{
        endAdornment: sufix ? <InputAdornment position="end">{sufix}</InputAdornment> : null,
        startAdornment: prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : null,
        error: hasError,
      }}
      inputProps={{
        maxLength: allowNegative ? maxLength + 1 : maxLength,
      }}
      onChange={(e: any) => {
        let negativeToken = "";

        let val: string = e.target.value;

        const newValue = Number(val || 0);
        if (newValue > 0 && newValue < 10) {
          val = val.replace('0', '');
        }
        if (allowNegative) {
          if (regexNegative.exec(val)) {
            negativeToken = "-";
            val = val.replace(regexNegative, "");
          }
        }
        val = negativeToken + val.toString().replace(/[^0-9]/, "");
        // setInputValue(val);
        if (onChangeValue) {
          onChangeValue(e.target.name, val);
        }
      }}

      onBlur={(e: any) => {
        if (onBlur) {
          onBlur()
        }
      }}
    />
  );
};

export { InputInteger };
